import ErrorsConstant from '../constants/errors';

const handleError = (error) => {
  if (error?.data?.data) {
    return `${error?.data?.data?.code || ''}: ${getMessage(error)}`;
  } else if (error?.status) {
    return `${error?.name || ''}: ${error?.message || error?.statusText}`;
  }
  return error || ErrorsConstant.generic;
};

const getMessage = (error) => {
  let msg = '';
  if (error?.data?.data?.error?.message) {
    msg =
      typeof error.data.data.error.message === 'string'
        ? error.data.data.error.message
        : JSON.stringify(error.data.data.error.message);
  } else if (error?.data?.data?.error) {
    msg = typeof error.data.data.error === 'string' ? error.data.data.error : JSON.stringify(error.data.data.error);
  } else {
    msg = error?.data?.data?.message || error?.message || ErrorsConstant.generic;
  }

  return msg;
};

export {handleError};
